import actions from './constants';

export const addCohortQuery = (code, category) => ({
  type: actions.ADD_COHORT_QUERY,
  code,
  category,
});

export const cloneCohortQuery = (code, category, queryUUID) => ({
  type: actions.CLONE_COHORT_QUERY,
  code,
  category,
  queryUUID,
});

export const deleteCohortQuery = (code, category, queryUUID) => ({
  type: actions.REMOVE_COHORT_QUERY,
  code,
  category,
  queryUUID,
});

export const showRenameQuery = (code, category, queryUUID) => ({
  type: actions.SHOW_RENAME_QUERY,
  code,
  category,
  queryUUID,
});

export const hideRenameQuery = (cancel) => ({
  type: actions.HIDE_RENAME_QUERY,
  cancel,
});

export const updateActiveQueryProperties = (properties) => ({
  type: actions.UPDATE_ACTIVE_QUERY_PROPERTIES,
  properties,
});
